import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Alert } from "@circleco/compass/components/Alert";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { useComposerError } from "./useComposerError";

import styles from "./composerError.module.css";

export const ComposerErrorToast = () => {
  const { displayError, isExiting, reset } = useComposerError(
    useShallow(s => ({
      displayError: s.displayError,
      isExiting: s.isExiting,
      reset: s.reset,
    })),
  );

  // The store is a global singleton, clear it when the composer unmounts so a
  // later-mounted composer never inherits a stale error.
  useEffect(() => () => reset(), [reset]);

  if (!displayError) return null;

  return (
    <div
      className={classNames(
        "absolute inset-x-2 bottom-full z-0 mb-3 bg-primary rounded-lg",
        isExiting ? styles.exit : styles.enter,
      )}
    >
      <Alert
        variant="destructive"
        icon="circle-x-filled"
        iconColor="danger"
        title={displayError.title}
        description={displayError.description}
      />
    </div>
  );
};
